<template>
  <div>
    <el-card
      style="min-height: 200px; padding: 20px"
      v-loading="loading"
      shadow="never"
    >
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="需求清单" prop="itemList">
            <div style="padding: 0px">
              <goods-sku-select :params="goodsSelectParams">
                <template slot="info-append" slot-scope="scope">
                  <div style="margin-top: 10px">
                    <template v-if="getItemBySkuGuid(scope.info.guid)">
                      <el-input-number
                        type="number"
                        v-model="
                          getItemBySkuGuid(scope.info.guid).plannedGoodsCount
                        "
                        @change="
                          handleItemGoodsChange(
                            getItemBySkuGuid(scope.info.guid)
                          )
                        "
                        style="width: 120px; margin-right: 10px"
                        size="small"
                        :disabled="!!getItemBySkuGuid(scope.info.guid).isDelete"
                        :min="1"
                      >
                      </el-input-number>
                      <el-button
                        size="small"
                        type="danger"
                        v-if="!getItemBySkuGuid(scope.info.guid).guid"
                        @click="
                          removeItemClick(getItemBySkuGuid(scope.info.guid))
                        "
                      >
                        移出
                      </el-button>
                      <el-link
                        v-if="getItemBySkuGuid(scope.info.guid).guid"
                        :type="
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? 'primary'
                            : 'danger'
                        "
                        :underline="false"
                        @click="deleteClick(getItemBySkuGuid(scope.info.guid))"
                      >
                        {{
                          getItemBySkuGuid(scope.info.guid).isDelete
                            ? "取消删除"
                            : "标记删除"
                        }}
                      </el-link>
                    </template>
                    <template v-else>
                      <el-button
                        size="small"
                        type="primary"
                        @click="handleAddItem(scope.info)"
                      >
                        添加到清单
                      </el-button>
                    </template>
                  </div>
                </template>
              </goods-sku-select>
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info :skuInfo="scope.row.skuInfo" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="补货需求数" width="200px">
                  <template slot-scope="scope">
                    <el-input-number
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.plannedGoodsCount"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="要货需求数"
                      style="width: 140px"
                      :min="1"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <div
                style="color: #999999; font-size: 14px; margin-top: 20px"
                v-if="editModel.totalGoodsCount > 0"
              >
                <span>合计：共</span>
                <span style="color: #f56c6c">
                  {{ (editModel.itemList && editModel.itemList.length) || 0 }}
                </span>
                <span>种</span>
                <span>（</span>
                <span style="color: #f56c6c">
                  {{ editModel.totalGoodsCount || 0 }}
                </span>
                <span>份商品</span>
                <span>）</span>
              </div>
              <div
                v-else
                style="color: #999999; font-size: 14px; margin-top: 20px"
              >
                * 请选择商品添加到清单
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit ||
                !editModel.itemList ||
                editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import goodsSkuInfo from '../../../../components/business/goodsSkuInfo.vue';
import goodsSkuSelect from '../../../../components/business/goodsSkuSelect.vue';

const defaultModel = {
  itemList: [],
  totalGoodsCount: 0,
}

export default {
  components: {
    goodsSkuInfo,
    goodsSkuSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    goodsSelectParams() {
      return {
        optSplit: 0
      }
    },
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        storeGuid: [
          {
            required: true,
            message: "请选择门店或仓库",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          }
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach(item => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    handleItemGoodsChange(item) {
      if (item.plannedGoodsCount < 0) {
        item.plannedGoodsCount = 0;
      }
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.totalGoodsCount = 0;
      (this.editModel.itemList || []).forEach((item) => {
        if (item.plannedGoodsCount < 0) {
          item.plannedGoodsCount = 0;
        }
        if (!item.isDelete) {
          this.editModel.totalGoodsCount
            += Number(item.plannedGoodsCount);
        }
      });
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      })
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    deleteClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemChange();
    },
    handleAddItem(item) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let flag = false;
      this.editModel.itemList.forEach((i) => {
        if (i.skuGuid == item.guid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.itemList.unshift({
          skuInfo: item,
          skuGuid: item.guid,
          plannedGoodsCount: 1,
          isDelete: 0,
        });
      }
      this.handleItemChange();
      this.validate();
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          let method = this.editModel.guid
            ? "biz.warehouse.demand.info.update"
            : "biz.warehouse.demand.info.create";
          this.requestApi(method, this.editModel, {
            showError: true
          }).then((resp) => {
            this.success("提交成功");
            this.$drawer.refreshDrawer();
            this.$drawer.backDrawer();
          }).finally(() => {
            this.editSubmit = false;
          });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
      this.handleItemChange();
    },
    fetchModel() {
      let guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel, {
          itemList: [],
        });
        this.handleModel();
      } else {
        // 编辑
        this.loading = true;
        this.errorMsg = null;
        this.editModel = null;
        return this.requestApi("biz.warehouse.demand.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        }).then((resp) => {
          return this.requestApi('biz.warehouse.demand.item.list', {
            demandGuid: resp.data.guid,
            storeGuid: resp.data.storeGuid,
          }).then((listResp) => {
            this.editModel = Object.assign({}, defaultModel, resp.data, {
              itemList: (listResp.data.list || []).map((item) => {
                item.isDelete = 0;
                return item;
              })
            })
            this.handleModel();
          })
        }).catch((err) => {
          this.errorMsg = (err && err.msg) || (err && err.message)
            || "数据加载失败";
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>